export const sort_search_results = (clinics, dentists, addresses) => {
    const predictions = [];
    console.log(clinics);
    console.log(dentists);
    console.log(addresses);
    for (let i = 0; i < clinics.length; i++){
        predictions.push({ data:clinics[i], type: 'clinic', icon: 'FaClinicMedical', name: clinics[i].clinic_name});
    }
    for (let i = 0; i < dentists.length; i++){
        predictions.push({ data:dentists[i], type: 'dentist', icon: 'FaUserMd', name: dentists[i].full_name});

    }
    for (let i = 0; i < addresses.length; i++){
        predictions.push({ data:addresses[i], type: 'location', icon: 'FaMapMarkerAlt', name: addresses[i].terms[0].value});
    }
    predictions.sort((a, b) => (a.name > b.name) ? 1 : -1)
    return predictions;
}

